import { StripHtml } from "@utils/helpers";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import { BasicActionsDropdown } from "shared/dropdowns/BasicActionsDropdown";
import { IconDispatcher } from "shared/Icons";
import { FlexAlignCenter } from "shared/ui-basics";
import styled, { css } from "styled-components/macro";
import BaseActions from "../actions/library-actions/BaseActions";

export const LibraryListCard = ({ data }) => {
	const history = useHistory();

	const getDescription = () => {
		if (!data?.description) return "-";
		if (data?.isCustom) return StripHtml(data?.description);
		return t(data?.description);
	};

	return (
		<Card iscustom={data?.isCustom}>
			<Container onClick={() => history.push(`/library-${data?.url}${data.url === "custom" ? `?id=${data?.id}` : ""}`)}>
				<FlexAlignCenter gap="16">
					<IconContainer>{IconDispatcher(data?.icon, "m-2", { size: "xl" })}</IconContainer>
					<Body>
						<Name className="w-100 text-truncate">
							<div>{data?.name || "-"}</div>
						</Name>
						<Description className="w-100 text-truncate">
							<div>{getDescription()}</div>
						</Description>
					</Body>
				</FlexAlignCenter>
				<Records>{<div className="ms-5">{data?.nRecords}</div>}</Records>
			</Container>
			<Actions>
				<BasicActionsDropdown actions={BaseActions({ library: data })} stopPropagation={true} />
			</Actions>
		</Card>
	);
};

const Actions = styled.div`
	visibility: hidden;
`;

const Card = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 16px;
	&:hover ${Actions} {
		${({ iscustom }) =>
			iscustom &&
			css`
				visibility: visible;
			`}
	}
`;

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	height: 64px;
	width: 1100px;
	border-radius: 4px;
	padding: 8px;
	&:hover {
		background-color: #f8fafc;
		cursor: pointer;
	}
`;

const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	border-radius: 8px;
	background: #f1f5f9;

	svg {
		width: 24px;
		height: 24px;
	}
`;

const Body = styled.div`
	font-family: "Inter";
`;

const Name = styled.div`
	color: #262626;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
	cursor: pointer;
	overflow: hidden;
	color: #333333;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	align-self: center !important;
	cursor: ${(props) => (props.desactivateclick === "true" ? "default" : "pointer")};
`;

const Description = styled.div`
	color: #595959;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	text-overflow: ellipsis;
	white-space: normal;
`;

const Records = styled.div`
	color: #262626;
	text-align: right;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;
